import { useMemo } from 'react';

import { useWebItemLocation } from '@confluence/web-item-location/entry-points/useWebItemLocation.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';

type UseWebItemsWithUrlsReturnType = Omit<ReturnType<typeof useWebItemLocation>, 'webSections'>;

export const useWebItemsWithUrls: ({
	accessStatus,
	edition,
}: {
	accessStatus: any;
	edition: any;
}) => UseWebItemsWithUrlsReturnType = ({ accessStatus, edition }) => {
	const { webItemParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	const { webItems, loading, error } = useWebItemLocation(webItemParams);

	// Memoised so the derived array keeps a stable identity while `webItems` is unchanged. This flows
	// into `useAppsItem` → `useMenuItemsConfig` → GSN's `items` prop, where a fresh array on every
	// render defeats the downstream memos and re-renders the whole navigation tree (COPPER-1474).
	return useMemo(
		() => ({
			webItems: !webItems
				? []
				: webItems.map((item) => ({
						...item,
						url: item?.url ? item.url.split('?')[0] : '',
					})),
			loading,
			error,
		}),
		[webItems, loading, error],
	);
};
